import { authHeaders, handleUnauthorized } from './http';
const BASE = '/api/stochastic';

async function req<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...authHeaders(), ...(init?.headers || {}) },
    ...init,
  });
  handleUnauthorized(res);
  if (!res.ok) throw new Error(await res.text() || res.statusText);
  return res.json();
}

export interface StochasticRun {
  scenario_id: string;
  meta: { n_state_variables: number; n_paths: number };
  state_keys: string[];
  initial_state: Record<string, number>;
  gcubed: {
    model_mode: string;
    sector_growth: Record<string, number>;
    export_volume_growth: number;
    import_volume_growth: number;
    current_account_pct_gdp: number;
    reer_index: number;
    sustainable_gdp_ceiling: number;
    notes: string[];
  };
  monte_carlo: {
    n_paths: number;
    n_steps: number;
    quantiles: Record<string, { p10: number; p50: number; p90: number; mean: number; std: number }>;
    gdp_path_quantiles: { p10: number[]; p50: number[]; p90: number[] };
  };
  fokker_planck_check: Record<string, number | string>;
  wilcoxon: { n: number; p_value: number | null; verdict: string; statistic?: number | null; z_approx?: number };
  external_gcubed: Record<string, unknown> | null;
}

export interface StateSpec {
  key: string; variable_id: string | null; display_name: string;
  bound_low: number; bound_high: number; vol_prior: number; mean_reversion: number;
}

export const stochasticApi = {
  stateRegistry: () => req<StateSpec[]>('/state-registry'),
  run: (scenario?: string, nPaths = 4000) =>
    req<StochasticRun>(`/run?n_paths=${nPaths}${scenario ? `&scenario=${encodeURIComponent(scenario)}` : ''}`),
  importGcubed: (body: unknown) => req('/gcubed/import', { method: 'POST', body: JSON.stringify(body) }),
};
